import { render, staticRenderFns } from "./DetailCPage.vue?vue&type=template&id=c5bba886&scoped=true&"
import script from "./DetailCPage.vue?vue&type=script&lang=js&"
export * from "./DetailCPage.vue?vue&type=script&lang=js&"
import style0 from "./DetailCPage.vue?vue&type=style&index=0&id=c5bba886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5bba886",
  null
  
)

export default component.exports